import { defineSlotRecipe } from "@pandacss/dev";
import tableBorderStyles from "./utils/tableBorderStyles";

export const aromaTableList = defineSlotRecipe({
  className: "aroma-table-list",
  jsx: ["TableList"],
  slots: ["root", "item", "cell"],
  base: {
    root: {
      ...tableBorderStyles,
      borderRadius: "l",
    },
    item: {
      display: "flex",
      paddingY: "padding.3",
      paddingX: "padding.4",
      gap: "gap.2",
      borderColor: "border.neutral.subtle",
      borderBottomWidth: { base: "m", _last: 0 },
      position: "relative",
    },
  },
});
